import { useEffect, useState } from 'react'
import { readRecentDocumentIds, subscribeRecentDocumentIds } from './recentDocumentsStore'

/** Local "recently attached" history — an ordering hint, not the data itself. */
export function useRecentDocumentIds() {
  const [ids, setIds] = useState(readRecentDocumentIds)

  useEffect(() => subscribeRecentDocumentIds(setIds), [])

  return ids
}
